// extracted by mini-css-extract-plugin
export default {"space":"styles_space__nMYOt","flip":"styles_flip__5KxT+","flipping":"styles_flipping__8v71B","qrWrapper":"styles_qrWrapper__MMBLR"};